// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import listActions from './list-actions'
import listFilter from './list-filter'
import advanceShipNoticeItem from '@src/views/shipping/advance-ship-notice/new/item-information/store'

const rootReducer = {
  navbar,
  layout,
  auth,
  listActions,
  listFilter,
  advanceShipNoticeItem
}

export default rootReducer
